
import Vue from 'vue'
import FilterWithSearch from './components/FilterWithSearch.vue'
import List from './components/List.vue'
import FilterWithoutSearch from './components/FilterWithoutSearch.vue'
import Pagination from './components/Pagination.vue'
import { IHeading } from './store/state'

// Interfaces for component typechecking!
interface AppData {}

interface AppMethods {}

interface AppComputed {
	showSearch: boolean
	heading: IHeading
	title: string
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		showSearch() {
			return this.$store.state.showSearch
		},
		title() {
			return this.$store.state.title
		},
		heading() {
			return this.$store.state.heading
		}
	},
	components: {
		FilterWithSearch,
		List,
		FilterWithoutSearch,
		Pagination
	}
})
